import { fetchSearchSuggestPrioritize, } from '@gn-audio/core';
import { combineFilters } from '../utils/combine-filters';
var ProductSelectorSpotV2Controller = (function () {
    function ProductSelectorSpotV2Controller($scope, $q) {
        var _this = this;
        this.$scope = $scope;
        this.$q = $q;
        this.initialize();
        var $deviceTypeJsonWatcher = this.$scope.$watch('deviceTypeJson', function (newValue) {
            _this.$scope.deviceTypes = JSON.parse(newValue);
            _this.$scope.deviceTypes.forEach(function (dt) {
                dt.selected = false;
            });
            $deviceTypeJsonWatcher();
        });
        var $filterJsonWatcher = this.$scope.$watch('filterJson', function (newValue) {
            _this.$scope.filters = JSON.parse(newValue);
            $filterJsonWatcher();
        });
        this.$scope.clearSearchQuery = function () {
            _this.$scope.searchQuery = '';
            _this.$scope.searchQueryChanged();
        };
        this.$scope.showMore = function () {
            _this.$scope.resultLimit += _this.$scope.pageSize;
        };
        this.$scope.searchQueryChanged = function () {
            _this.$scope.cannotFindMyProductVisible = false;
            (_this.$scope.deviceTypes || []).forEach(function (dt) {
                dt.selected = false;
            });
            if (_this.$scope.searchQuery !== '' || _this.anyFilterSelected) {
                var parameters = {
                    filter: combineFilters(_this.$scope.filters, _this.$scope.preFilterQuery),
                    search: _this.$scope.searchQuery,
                    top: 50,
                };
                _this.$scope.loading = true;
                _this.$q.when(fetchSearchSuggestPrioritize(parameters))
                    .then(function (results) {
                    _this.$scope.results = (results === null || results === void 0 ? void 0 : results.items) || [];
                    _this.$scope.resultLimit = _this.$scope.pageSize;
                    _this.$scope.resultCount = (results === null || results === void 0 ? void 0 : results.count) || 0;
                    _this.$scope.loading = false;
                }, function () {
                    _this.$scope.results = [];
                    _this.$scope.resultLimit = 0;
                    _this.$scope.resultCount = 0;
                    _this.$scope.loading = false;
                });
            }
            else {
                _this.$scope.results = undefined;
                _this.$scope.resultLimit = 0;
                _this.$scope.resultCount = 0;
            }
        };
        this.$scope.toggleCannotFindMyProduct = function () {
            _this.$scope.cannotFindMyProductVisible = !_this.$scope.cannotFindMyProductVisible;
        };
        this.$scope.searchApplied = function () {
            return _this.$scope.searchQuery !== '' || _this.anyFilterSelected;
        };
        this.$scope.isLabeled = function (item) {
            return (item.itemType === 'Family' && item.familyState < 3) ||
                (item.itemType === 'Group' && item.groupState < 3);
        };
    }
    ProductSelectorSpotV2Controller.prototype.initialize = function () {
        this.$scope.searchQuery = '';
        this.$scope.pageSize = 10;
        this.$scope.resultCount = 0;
        this.$scope.resultLimit = 0;
        this.$scope.loading = false;
        this.$scope.cannotFindMyProductVisible = false;
    };
    Object.defineProperty(ProductSelectorSpotV2Controller.prototype, "anyFilterSelected", {
        get: function () {
            return (Array.isArray(this.$scope.filters) &&
                this.$scope.filters.some(function (f) { return Boolean(f.selected); }));
        },
        enumerable: false,
        configurable: true
    });
    ProductSelectorSpotV2Controller.$inject = ['$scope', '$q'];
    return ProductSelectorSpotV2Controller;
}());
export { ProductSelectorSpotV2Controller };
